// extracted by mini-css-extract-plugin
export default {"Information":"Information_Information__LXQFX","Information__container":"Information_Information__container__ousKH"};